/** * * Asynchronously loads the component for
AddLine
* */ import { lazyLoad } from "utils/loadable";
export const AddLine = lazyLoad(
  () => import("./index"),
  (module) => module.AddLine
);
